// Barre d'achat fixe : visible quand le bouton d'achat principal est sorti de l'écran par le haut.
// Reprend le prix affiché (palier sélectionné ou variante) et déclenche le vrai bouton d'achat.
if (!customElements.get('mp-achat-fixe')) {
  class MpAchatFixe extends HTMLElement {
    connectedCallback() {
      this.boutonPrincipal = document.querySelector('[data-mp-atc]');
      this.bouton = this.querySelector('[data-mp-achat-fixe-bouton]');
      this.prix = this.querySelector('[data-mp-achat-fixe-prix]');
      this.barre = this.querySelector('[data-mp-achat-fixe-barre]');
      this.libelleInitial = this.bouton.textContent.trim();

      this.bouton.addEventListener('click', (event) => {
        if (!this.boutonPrincipal) return; // pas de formulaire sur la page : on suit le lien produit
        event.preventDefault();
        if (this.boutonPrincipal.disabled) {
          this.boutonPrincipal.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.boutonPrincipal.click();
      });

      this.synchroniser = () => window.requestAnimationFrame(() => this.majDepuisPage());
      document.addEventListener('mp:variante:change', this.synchroniser);
      document.addEventListener('mp:palier:change', this.synchroniser);
      this.majDepuisPage();

      if (!this.boutonPrincipal || !('IntersectionObserver' in window)) {
        this.afficher(Boolean(this.boutonPrincipal) === false);
        return;
      }
      this.observateur = new IntersectionObserver(([entree]) => {
        const auDessus = !entree.isIntersecting && entree.boundingClientRect.top < 0;
        this.afficher(auDessus);
      });
      this.observateur.observe(this.boutonPrincipal);
    }

    disconnectedCallback() {
      this.observateur?.disconnect();
      document.removeEventListener('mp:variante:change', this.synchroniser);
      document.removeEventListener('mp:palier:change', this.synchroniser);
    }

    afficher(visible) {
      this.hidden = false;
      this.classList.toggle('is-visible', visible);
      this.toggleAttribute('inert', !visible);
      document.body.classList.toggle('mp-achat-fixe-actif', visible);
    }

    // Prix : celui du palier coché s'il y en a, sinon celui du bloc prix de la page
    majDepuisPage() {
      const palier = document.querySelector('[data-mp-palier]:checked');
      const zone = palier
        ? document.querySelector(`[data-mp-palier-prix="${palier.dataset.index}"]`)
        : document.querySelector('[data-mp-maj="prix"]');
      const actuel = zone?.querySelector('.mp-prix__actuel');
      const barre = zone?.querySelector('.mp-prix__barre');
      if (actuel) this.prix.textContent = actuel.textContent.trim();
      if (this.barre) {
        this.barre.hidden = !barre;
        if (barre) this.barre.textContent = barre.textContent.trim();
      }
      if (this.boutonPrincipal) {
        const libelle = this.boutonPrincipal.querySelector('[data-mp-atc-libelle]');
        this.bouton.classList.toggle('is-desactive', this.boutonPrincipal.disabled);
        this.bouton.textContent =
          this.boutonPrincipal.disabled && libelle ? libelle.textContent.trim() : this.libelleInitial;
      }
    }
  }

  customElements.define('mp-achat-fixe', MpAchatFixe);
}
